import React, { useState, useRef } from 'react';

import NavbarLink from 'components/App/Navbar/NavbarLink';

function safeCallBeacon(msg) {
  try {
    // eslint-disable-next-line new-cap
    window.Beacon(msg);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

/**
 * Essentially a custom button for opening and closing the HelpScout Beacon
 */
export const GetHelpLink = () => {
  const [beaconIsOpen, setBeaconIsOpen] = useState(false);
  const containerEl = useRef(null);

  const handleClick = e => {
    e.preventDefault();
    if (beaconIsOpen) {
      safeCallBeacon('close');
      setBeaconIsOpen(false);
    } else {
      safeCallBeacon('open');
      setBeaconIsOpen(true);
    }
  };

  return (
    <div ref={containerEl}>
      <NavbarLink icon="comment" href="" onClick={handleClick}>
        Get Help
      </NavbarLink>
    </div>
  );
};

export default GetHelpLink;
